/**
 * Print-route snapshot fetcher.
 *
 * The one and only API call a print route makes. No session, no
 * Authorization header — the opaque snapshot id IS the cap (UUID v4,
 * 60s TTL in v1).
 */
import type { SnapshotEnvelope } from './types'

export async function fetchSnapshot(id: string): Promise<SnapshotEnvelope> {
  const res = await fetch(`/api/print/snapshot/${encodeURIComponent(id)}`, {
    // No `credentials: 'include'` — the endpoint is intentionally
    // session-less. The headless browser hits it with no cookies anyway.
  })
  if (!res.ok) {
    const body = await res.json().catch(() => ({}))
    throw new Error(
      body?.message || body?.error || `Failed to load snapshot (${res.status})`,
    )
  }
  return res.json()
}
